<template>
  <vs-card>
    <div slot="header">
      <h3>Análise de Boletos</h3>
    </div>
    <div v-if="!listBoletos.length">
      <vs-alert style="height: auto" active="true" color="danger">
        Nenhum Registro Financeiro Encontrado
      </vs-alert>
    </div>
    <div v-else>
      <div v-for="(boleto, index) of listBoletos" :key="index">
        <div class="relative pb-4 mb-2 w-full" v-if="!isBoletoExcluido(boleto)">
          <vs-card>
            <div class="flex w-full">
              <FinancialCardChip
                :title="boleto.placa"
                color="rgb(7, 143, 207)"
              />
              <FinancialCardChip
                v-if="boleto.status"
                :title="boleto.status"
                :color="getStatusBoletoColor(boleto)"
              />
            </div>
            <div class="vx-col w-full lg:flex lg:justify-between ml-2">
              <FinancialCardItem title="TIPO" :value="boleto.tipoBoleto" />
              <FinancialCardItem title="SITUAÇÃO" :value="boleto.situacao" />
              <FinancialCardItem
                title="EMISSÃO"
                :value="boleto.data_emissao | formatDate"
              />
              <FinancialCardItem
                title="VENCIMENTO"
                :value="boleto.data_vencimento"
              />
              <FinancialCardItem
                title="DATA ORIG."
                :value="boleto.data_vencimento_original | formatDate"
              />
              <FinancialCardItem title="TIPO" :value="boleto.tipoBoleto" />
              <FinancialCardItem
                title="PAGAMENTO"
                :value="boleto.data_pagamento | formatDate"
              />
              <FinancialCardItem
                title="VALOR"
                :value="boleto.valor_boleto | currency"
              />
              <FinancialCardItem
                title="VALOR PAGO"
                :value="boleto.valor_pagamento | currency"
              />
            </div>
          </vs-card>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import FinancialCardChip from '../../../../../components/financial-card/FinancialCardChip.vue';
import FinancialCardItem from '../../../../../components/financial-card/FinancialCardItem.vue';

export default {
  props: ['listBoletos'],
  methods: {
    getStatusBoletoColor(data) {
      if (data == 'BAIXADO') return 'success';
      if (data == 'ABERTO') return 'warning';
      return 'danger';
    },
    isBoletoExcluido(item) {
      const isBoletoExcluidoResult =
        item.deletedAt === null && item.situacao === 'EXCLUIDO';

      return isBoletoExcluidoResult;
    },
  },
  components: { FinancialCardItem, FinancialCardChip },
};
</script>
